<template>
    <svg :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <g>
            <path d="M28.6,21.4c.6.6.6,1.5,0,2.1-.6.6-1.5.6-2.1,0,0,0,0,0,0,0-.6-.6-1.2-1-2-1.3-2.1-.8-4.6-.3-6.2,1.3l-7.2,7.2c-2.2,2.3-2.2,5.9,0,8.2,2.3,2.2,5.9,2.2,8.2,0l6.2-6.2c.6-.6,1.5-.6,2.1,0s.6,1.5,0,2.1l-6.2,6.2c-3.4,3.4-8.9,3.4-12.3,0-3.4-3.4-3.4-8.9,0-12.3l7.2-7.2c2.5-2.4,6.1-3.2,9.3-1.9,1.1.4,2.1,1.1,3,1.9Z"/>
        </g>
        <g>
            <path d="M40.9,9.1c3.4,3.4,3.4,8.9,0,12.3l-6.2,6.2c-3.4,3.4-8.9,3.4-12.3,0h0c-.6-.6-.6-1.5,0-2.1.6-.6,1.5-.6,2.1,0,2.3,2.2,6,2.2,8.2,0l6.2-6.2c2.2-2.3,2.2-5.9,0-8.2-2.3-2.2-5.9-2.2-8.2,0l-6.2,6.2c-.6.6-1.5.6-2.1,0s-.6-1.5,0-2.1l6.2-6.2c3.4-3.4,8.9-3.4,12.3,0Z"/>
        </g>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>